import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {WelcomeComponent} from './components/welcome/welcome.component';
import {PlanPreviewComponent} from './components/view-types/plan-preview/plan-preview.component';
import { AdminViewerComponent } from './components/view-types/admin-viewer/admin-viewer.component';
import { EmployeeViewerComponent } from './components/view-types/employee-viewer/employee-viewer.component';

const routes: Routes = [
  { path: '', component: WelcomeComponent },
  { path: 'preview', component: PlanPreviewComponent },
  { path: 'admin-view', component: AdminViewerComponent },
  { path: 'employee-view', component: EmployeeViewerComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
